<template>
  <div class="music-footer">
    Footer
  </div>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  }
};
</script>
